import type { RouteObject } from 'react-router'
import { ensure, q } from '../../data/queries'
import { moduleLoader } from '../../lib/loaders'

export const applicationsRoutes: RouteObject[] = [
  { path: 'applications', lazy: async () => ({ Component: (await import('./ApplicationsPage')).default }), loader: moduleLoader('applications', () => ensure(q.applications)) },
]

/** Admin routes, mounted under /manage. */
export const applicationsManageRoutes: RouteObject[] = [
  { path: 'applications', lazy: async () => ({ Component: (await import('./ManageApplications')).default }), loader: moduleLoader('applications', () => ensure(q.manage.applications), { admin: true }) },
]
